import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { select, Store } from '@ngxs/store';
import { Rights } from '@shared/enums/rights.enum';
import { TeamData } from '@shared/models/account.model';
import { IdentityData } from '@shared/models/prefs.model';
import { PrefsManager } from '@shared/services/prefs-manager.service';
import { AccountState } from '@shared/states/account.state';
import { TrialStatusRead } from '@shared/states/billing.actions';
import { Observable, of } from 'rxjs';
import { concatMap } from 'rxjs/operators';

export enum TrialExpiredResponse {
  Cancel = 1,
  Revert,
  Select,
}

@Component({
  templateUrl: './trial-expired.dialog.html',
  styleUrls: ['./trial-expired.dialog.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TrialExpired {
  readonly store = inject(Store);
  readonly pm = inject(PrefsManager);
  readonly md = inject<MatDialogRef<TrialExpired, TrialExpiredResponse>>(MatDialogRef);

  responses = TrialExpiredResponse;

  readonly team = select(AccountState.team);

  readonly teamLogo = select(AccountState.teamLogo);

  readonly owner$: Observable<IdentityData | null> = this.store.select(AccountState.isTeamOwner).pipe(
    concatMap((isOwner) => (isOwner ? of(null) : this.store.select(AccountState.team))),
    concatMap((team: TeamData | null) => {
      if (team) {
        const [owner] = Object.entries(team.users).find(([, rt]) => Rights.hasRights(Rights.OWNER, rt)) || [''];

        if (owner) {
          return this.pm.loadIdentity(owner);
        }
      }

      return of(null);
    }),
  );
  dialogTitle = $localize`:dialog title@@zef-i18n-00162:Trial Period is Over`;
  dialogLabel = $localize`:dialog label@@zef-i18n-00098:Unnamed organization`;
  dialogHeader = $localize`:dialog header@@zef-i18n-00163:Select new plan or stay on the current one.`;

  constructor() {
    this.md.afterClosed().subscribe((response) => {
      this.store.dispatch(new TrialStatusRead(response || TrialExpiredResponse.Cancel));
    });
  }
}
